import { AutoHeightContainer, useTherapproveDrawers } from "@therapprove/common";
import { TeamHeader } from "./TeamHeader";
import { TeamList } from "./TeamList";
import { useTeam } from "./useTeam";

export const Team = () => {
    // State
    const { search, setSearch, debouncedSearch, filters, setFilters } =
        useTeam();
    const { team: teamDrawer } = useTherapproveDrawers();

    return (
        <AutoHeightContainer style={{ gap: "1rem" }}>
            <TeamHeader
                search={search}
                setSearch={setSearch}
                filters={filters}
                setFilters={setFilters}
                onAddNew={() => teamDrawer.open()}
            />
            <TeamList
                search={debouncedSearch}
                filters={filters}
                onRowClick={(userId) => teamDrawer.open({ userId })}
            />
        </AutoHeightContainer>
    );
};
